import React, { Component } from 'react'
import Divider from 'material-ui/Divider'

export class HorizontalDivider extends Component {

    render() {
        return <Divider />
    }
}
